import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import FilterModelBody from "../filter-model-body";

interface FilterModelProps {
  showModel: boolean;
  setShowModel: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function FilterMobile({
  showModel,
  setShowModel
}: FilterModelProps) {
  return (
    <Sidebar
      visible={showModel}
      position="top"
      onHide={() => setShowModel(false)}
      className={styles.FilterModel}
    >
      <FilterModelBody setShowModel={setShowModel} />
    </Sidebar>
  );
}
